import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_URL;
export const api = axios.create({ baseURL: `${BASE}/api` });

api.interceptors.request.use((c) => {
  const t = localStorage.getItem("ph_token");
  if (t) c.headers.Authorization = `Bearer ${t}`;
  return c;
});

api.interceptors.response.use(
  (r) => r,
  (err) => {
    if (err.response?.status === 401 && localStorage.getItem("ph_token")) {
      localStorage.removeItem("ph_token");
      window.dispatchEvent(new Event("ph:signout"));
    }
    return Promise.reject(err);
  },
);

export const errMsg = (e) => e?.response?.data?.detail || e?.message || "Something went wrong";
